module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', {
    staticClass: "form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit();
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('my-input', {
    ref: "username",
    staticClass: "the-input",
    attrs: {
      "wide": "",
      "required": "",
      "no-required-sign": "",
      "blur-check": "",
      "placeholder": "用户名"
    },
    model: {
      value: (_vm.form.username),
      callback: function($$v) {
        _vm.$set(_vm.form, "username", $$v)
      },
      expression: "form.username"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('my-input', {
    ref: "phone",
    staticClass: "the-input",
    attrs: {
      "type": "number",
      "wide": "",
      "required": "",
      "no-required-sign": "",
      "blur-check": "",
      "placeholder": "手机号"
    },
    model: {
      value: (_vm.form.phone),
      callback: function($$v) {
        _vm.$set(_vm.form, "phone", $$v)
      },
      expression: "form.phone"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('my-input', {
    ref: "password",
    staticClass: "the-input",
    attrs: {
      "type": "password",
      "wide": "",
      "required": "",
      "no-required-sign": "",
      "blur-check": "",
      "placeholder": "密码"
    },
    model: {
      value: (_vm.form.password),
      callback: function($$v) {
        _vm.$set(_vm.form, "password", $$v)
      },
      expression: "form.password"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('button', {
    staticClass: "btn wide",
    on: {
      "click": function($event) {
        _vm.submit();
      }
    }
  }, [_vm._v("提交" + _vm._s(_vm.loading ? '...' : ''))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2148c25c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/register.vue
// module id = 308
// module chunks = 1